var G = Object.defineProperty, Y = Object.defineProperties;
var q = Object.getOwnPropertyDescriptors;
var x = Object.getOwnPropertySymbols;
var F = Object.prototype.hasOwnProperty, W = Object.prototype.propertyIsEnumerable;
var E = (n, e, t) => e in n ? G(n, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : n[e] = t, R = (n, e) => {
  for (var t in e || (e = {}))
    F.call(e, t) && E(n, t, e[t]);
  if (x)
    for (var t of x(e))
      W.call(e, t) && E(n, t, e[t]);
  return n;
}, _ = (n, e) => Y(n, q(e));
var A = (n, e) => {
  var t = {};
  for (var r in n)
    F.call(n, r) && e.indexOf(r) < 0 && (t[r] = n[r]);
  if (n != null && x)
    for (var r of x(n))
      e.indexOf(r) < 0 && W.call(n, r) && (t[r] = n[r]);
  return t;
};
import { jsx as U } from "react/jsx-runtime";
import * as h from "react";
import L, { useLayoutEffect as X } from "react";
import { g as Z } from "./get-env-CiXMSQeN.js";
import { f as D, u as J } from "./factory-ueRxoNOV.js";
import { I as B } from "./InputBase-Cabx1d9o.js";
function w() {
  return w = Object.assign ? Object.assign.bind() : function(n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, w.apply(null, arguments);
}
function K(n, e) {
  if (n == null) return {};
  var t = {};
  for (var r in n) if ({}.hasOwnProperty.call(n, r)) {
    if (e.indexOf(r) !== -1) continue;
    t[r] = n[r];
  }
  return t;
}
var Q = X, V = function(e) {
  var t = L.useRef(e);
  return Q(function() {
    t.current = e;
  }), t;
}, I = function(e, t) {
  if (typeof e == "function") {
    e(t);
    return;
  }
  e.current = t;
}, ee = function(e, t) {
  var r = L.useRef();
  return L.useCallback(function(i) {
    e.current = i, r.current && I(r.current, null), r.current = t, t && I(t, i);
  }, [t]);
}, P = {
  "min-height": "0",
  "max-height": "none",
  height: "0",
  visibility: "hidden",
  overflow: "hidden",
  position: "absolute",
  "z-index": "-1000",
  top: "0",
  right: "0",
  display: "block"
}, te = function(e) {
  Object.keys(P).forEach(function(t) {
    e.style.setProperty(t, P[t], "important");
  });
}, k = te, o = null, O = function(e, t) {
  var r = e.scrollHeight;
  return t.sizingStyle.boxSizing === "border-box" ? r + t.borderSize : r - t.paddingSize;
};
function re(n, e, t, r) {
  t === void 0 && (t = 1), r === void 0 && (r = 1 / 0), o || (o = document.createElement("textarea"), o.setAttribute("tabindex", "-1"), o.setAttribute("aria-hidden", "true"), k(o)), o.parentNode === null && document.body.appendChild(o);
  var i = n.paddingSize, s = n.borderSize, a = n.sizingStyle, g = a.boxSizing;
  Object.keys(a).forEach(function(l) {
    var m = l;
    o.style[m] = a[m];
  }), k(o), o.value = e;
  var u = O(o, n);
  o.value = e, u = O(o, n), o.value = "x";
  var f = o.scrollHeight - i, d = f * t;
  g === "border-box" && (d = d + i + s), u = Math.max(d, u);
  var v = f * r;
  return g === "border-box" && (v = v + i + s), u = Math.min(v, u), [u, f];
}
var j = function() {
}, ne = function(e, t) {
  return e.reduce(function(r, i) {
    return r[i] = t[i], r;
  }, {});
}, ie = [
  "borderBottomWidth",
  "borderLeftWidth",
  "borderRightWidth",
  "borderTopWidth",
  "boxSizing",
  "fontFamily",
  "fontSize",
  "fontStyle",
  "fontWeight",
  "letterSpacing",
  "lineHeight",
  "paddingBottom",
  "paddingLeft",
  "paddingRight",
  "paddingTop",
  // non-standard
  "tabSize",
  "textIndent",
  // non-standard
  "textRendering",
  "textTransform",
  "width",
  "wordBreak",
  "wordSpacing",
  "scrollbarGutter"
], oe = !!document.documentElement.currentStyle, ae = function(e) {
  var t = window.getComputedStyle(e);
  if (t === null)
    return null;
  var r = ne(ie, t), i = r.boxSizing;
  if (i === "")
    return null;
  oe && i === "border-box" && (r.width = parseFloat(r.width) + parseFloat(r.borderRightWidth) + parseFloat(r.borderLeftWidth) + parseFloat(r.paddingRight) + parseFloat(r.paddingLeft) + "px");
  var s = parseFloat(r.paddingBottom) + parseFloat(r.paddingTop), a = parseFloat(r.borderBottomWidth) + parseFloat(r.borderTopWidth);
  return {
    sizingStyle: r,
    paddingSize: s,
    borderSize: a
  };
}, ue = ae;
function H(n, e, t) {
  var r = V(t);
  h.useLayoutEffect(function() {
    var i = function(a) {
      return r.current(a);
    };
    if (n)
      return n.addEventListener(e, i), function() {
        return n.removeEventListener(e, i);
      };
  }, []);
}
var se = function(e, t) {
  H(document.body, "reset", function(r) {
    e.current.form === r.target && t(r);
  });
}, de = function(e) {
  H(window, "resize", e);
}, ce = function(e) {
  H(document.fonts, "loadingdone", e);
}, fe = ["cacheMeasurements", "maxRows", "minRows", "onChange", "onHeightChange"], le = function(e, t) {
  var r = e.cacheMeasurements, i = e.maxRows, s = e.minRows, a = e.onChange, g = a === void 0 ? j : a, u = e.onHeightChange, f = u === void 0 ? j : u, d = K(e, fe), v = d.value !== void 0, l = h.useRef(null), m = ee(l, t), T = h.useRef(0), S = h.useRef(), p = function() {
    var c = l.current, y = r && S.current ? S.current : ue(c);
    if (y) {
      S.current = y;
      var C = re(y, c.value || c.placeholder || "x", s, i), b = C[0], $ = C[1];
      T.current !== b && (T.current = b, c.style.setProperty("height", b + "px", "important"), f(b, {
        rowHeight: $
      }));
    }
  }, M = function(c) {
    v || p(), g(c);
  };
  return h.useLayoutEffect(p), se(l, function() {
    if (!v) {
      var z = l.current.value;
      requestAnimationFrame(function() {
        var c = l.current;
        c && z !== c.value && p();
      });
    }
  }), de(p), ce(p), /* @__PURE__ */ h.createElement("textarea", w({}, d, {
    onChange: M,
    ref: m
  }));
}, he = /* @__PURE__ */ h.forwardRef(le);
const ge = {}, N = D((n, e) => {
  const d = J(
    "Textarea",
    ge,
    n
  ), { autosize: t, maxRows: r, minRows: i, __staticSelector: s, resize: a } = d, g = A(d, ["autosize", "maxRows", "minRows", "__staticSelector", "resize"]), u = t && Z() !== "test", f = u ? { maxRows: r, minRows: i } : {};
  return /* @__PURE__ */ U(
    B,
    R(_(R({
      component: u ? he : "textarea",
      ref: e
    }, g), {
      __staticSelector: s || "Textarea",
      multiline: !0,
      "data-no-overflow": t && r === void 0 || void 0,
      __vars: { "--input-resize": a }
    }), f)
  );
});
N.classes = B.classes;
N.displayName = "@mantine/core/Textarea";
export {
  N as T
};
